<template>
  <f7-page class="main-new-mixted-order-line">
    <TheNavbar
      class="container-navbar"
      :nav-title="$t('commercialization.common.newMixedOrderLine')"
      :back-btn-enable="true"
      :back-callback="BackToMain"
      add-btn-enable
      @add-btn="PressBtnAdd"
    />

    <div class="container-list">
      <f7-list
        v-for="(item, i) in mixedOrderLines"
        :key="i"
        class="container-list__list"
        media-list
      >
        <f7-list-item
          class="container-list__list--item"
          @click="GetOrderLineSelected(item)"
        >
          <template #title>
            <div class="truncate-x2">
              <div
                v-if="item.TipoLinea === 1"
              >
                {{ item.TextoLinea }}
              </div>
              <div
                v-else
              >
                <span
                  v-if="item.Articulo.Composicion === null"
                >
                  {{ item.Articulo.Nombre }}
                </span>
                <span v-else>
                  <span
                    v-for="(comp, j) in item.Articulo.Composicion.Componentes"
                    :key="j"
                    class="text"
                  >
                    <span v-if="comp.Orden === 2">
                      {{ comp.Nombre }}
                    </span>
                  </span>
                </span>
                <span>
                  {{ ` + ${item.InfoEnvase.Nombre} + ${item.InfoPale.Nombre}` }}
                </span>
              </div>
            </div>
          </template>

          <template #subtitle>
            <div
              v-if="item.TipoLinea !== 1"
              class="mt-3 display-flex align-items-center justify-content-space-between"
            >
              <div class="display-flex align-items-center text-color-metal-shade">
                <img
                  class="margin-right-half"
                  src="@/static/icons/ic_palet_grey.svg"
                >

                <div>
                  {{ `${item.CantidadPales} ${$t('commercialization.common.palletsLabel')}` }}
                </div>
              </div>
              <div class="display-flex align-items-center text-color-metal-shade">
                <img
                  class="margin-right-half"
                  src="@/static/icons/ic_box_grey.svg"
                >
                <div>
                  {{ `${item.EnvasesPorPalet} ${$t('commercialization.common.packagesPerPalletShort')}` }}
                </div>
              </div>
              <div class="text-color-tomate font-semibold">
                {{ `${item.Precio} ${divisaSelected?.Simbolo ?? ''}/${item.PrecioPor?.Codigo}` }}
              </div>
            </div>
          </template>
        </f7-list-item>
      </f7-list>
    </div>
    <div class="content-button">
      <f7-button
        class="content-button__save"
        fill
        color="green"
        @click="SaveMixedOrderLine"
      >
        {{ $t('common.save') }}
      </f7-button>
    </div>
    <f7-actions
      :opened="LineItemOptions"
      @actions:closed="LineItemOptions = false"
    >
      <f7-actions-group
        v-if="orderLineSelected"
        class="order-detail-action-item-options"
      >
        <div class="order-detail-action-item-options__title display-flex align-items-center justify-content-space-between">
          <div class="display-flex align-items-center">
            <img
              class="margin-right"
              src="@/static/icons/ic_clock.svg"
              height="36"
              width="36"
            >
            <span class="text-color-metal-dark size-16 font-medium"> {{ deliveryDate }}</span>
          </div>
          <div
            class="display-flex align-items-center"
            @click="CloseLineItemOptions()"
          >
            <img
              src="@/static/icons/ic_close_grey2.svg"
              height="36"
              width="36"
            >
          </div>
        </div>
        <div class="size-16 font-semibold text-color-berenjena truncate-x2 mt-6 mb-4">
          <span
            v-if="orderLineSelected.TipoLinea === 1"
          >
            {{ orderLineSelected.TextoLinea }}
          </span>
          <span v-else>
            <span
              v-if="orderLineSelected.Articulo.Composicion === null"
            >
              {{ orderLineSelected.Articulo.Nombre }}
            </span>
            <span v-else>
              <span
                v-for="(comp, i) in orderLineSelected.Articulo.Composicion.Componentes"
                :key="i"
              >
                <span v-if="comp.Orden === 2">{{ comp.Nombre }}</span>
              </span>
            </span>
            <span>
              {{ ` + ${orderLineSelected.InfoEnvase.Nombre} + ${orderLineSelected.InfoPale.Nombre}` }}
            </span>
          </span>
        </div>
        <div
          v-if="orderLineSelected.TipoLinea !== 1"
          class="display-flex"
        >
          <div class="display-flex align-items-center text-color-metal-shade mr-4">
            <img
              class="margin-right-half"
              src="@/static/icons/ic_palet_grey.svg"
            >
            <div>{{ `${orderLineSelected.CantidadPales} ${$t('commercialization.common.palletsLabel')}` }}</div>
          </div>
          <div class="display-flex align-items-center text-color-metal-shade mr-4">
            <img
              class="margin-right-half"
              src="@/static/icons/ic_box_grey.svg"
            >
            <div>{{ `${orderLineSelected.EnvasesPorPalet} ${$t('commercialization.common.packagesPerPalletShort')}` }}</div>
          </div>
          <div class="display-flex align-items-center text-color-tomate font-medium mr-4">
            {{ `${orderLineSelected.Precio} ${divisaSelected?.Simbolo ?? ''}/${orderLineSelected.PrecioPor?.Codigo}` }}
          </div>
        </div>
        <div class="display-flex mt-7">
          <f7-actions-button
            class="order-detail-action-item-options__btn-duplicate mr-3"
            @click="duplicateLine(orderLineSelected)"
          >
            <img
              class="margin-right"
              src="@/static/img/ic_duplicate_white.svg"
            >
            <span>{{ $t('common.repeatLine') }}</span>
          </f7-actions-button>
          <f7-actions-button
            class="order-detail-action-item-options__btn-edit"
            @click="editLine(orderLineSelected)"
          >
            <img
              class="margin-right"
              src="@/static/img/ic_edit_without_borders.svg"
            >
            {{ $t('common.edit') }}
          </f7-actions-button>
        </div>
        <f7-actions-button
          class="order-detail-action-item-options__btn-delete mt-3 mb-3"
          @click="DeleteLine(orderLineSelected)"
        >
          <img
            class="margin-right"
            src="@/static/icons/ic_delete2.svg"
            width="16"
            height="16"
          >
          {{ $t('commercialization.common.deleteLine').toUpperCase() }}
        </f7-actions-button>
      </f7-actions-group>
    </f7-actions>
  </f7-page>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useAppOrdersStore } from '@/js/stores/appOrders';

import TheNavbar from '@/components/TheNavbar.vue';
import { Log } from '@/js/common/HIDebuggingSupport';
import { ConfirmDialogGH, HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import APIErp from '@/js/services/APIErp';
import SoporteFechaYHora from '@/js/common/HIConversionSupport';
import { f7 } from 'framework7-vue';
import { sleep } from '@/js/utils/sleep';

export default {
  name: 'NewMixtedOrderLine',
  components: {
    TheNavbar,
  },
  props: {
    nuevoPedido: { type: Boolean, default: true },
  },

  data() {
    return {
      orderLineSelected: null,
      LineItemOptions: false,
      deliveryDate: null,
      deletedLines: [],
    };
  },

  computed: {
    ...mapState(useAppOrdersStore, ['salesOrderLine']),
    ...mapWritableState(useAppOrdersStore, [
      'actualOrder',
      'mixedOrderLines',
      'estadoLineaEditada',
      'estadoLineaMixtaEdit',
      'estadoLineaCopiada',
      'salesOrderLine',
    ]),

  },

  created() {
    this.StartComponent();
  },

  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      this.deliveryDate = SoporteFechaYHora.obtenerDDMMAA(this.actualOrder.FechaEntrega);
      if (this.estadoLineaEditada) {
        const elementosFiltrados = this.actualOrder.lineasPedidoVenta.filter((elemento) => elemento.PaleMixto === this.salesOrderLine.PaleMixto);
        this.mixedOrderLines = elementosFiltrados;
        this.estadoLineaEditada = false;
      }

      if (this.estadoLineaCopiada) {
        const lista = { ...this.actualOrder };
        // se hace esto del JSON.PARSE porque en mi caso, pillaba la referencia a la propiedad vuex y me hacia el cambio en ambos lados
        const elementosFiltrados = JSON.parse(JSON.stringify(this.actualOrder.lineasPedidoVenta)).filter((elemento) => elemento.PaleMixto === this.salesOrderLine.PaleMixto);

        // se les cambia el idTemporal a uno nuevo y el id a 0 pq son nuevas lineas
        // cambiar el número de paleMixto ya que es un pale copiado y por lo tanto uno nuevo
        let paleMixto = 0;
        if (lista.lineasPedidoVenta.length < 1) {
          paleMixto = 1;
        } else {
          const objetoMasGrande = lista.lineasPedidoVenta.reduce((maxObjeto, objeto) => {
            if (objeto.PaleMixto > maxObjeto.PaleMixto) {
              return objeto;
            }
            return maxObjeto;
          });
          paleMixto = objetoMasGrande.PaleMixto;
        }

        let ultimoIdTemporal = this.actualOrder.lineasPedidoVenta.length;
        for (let i = 0; i < elementosFiltrados.length; i += 1) {
          const element = elementosFiltrados[i];
          element.Id = 0;
          element.IdTemporal = ultimoIdTemporal;
          element.PaleMixto = paleMixto + 1;
          ultimoIdTemporal += 1;
        }

        this.mixedOrderLines = elementosFiltrados;
        this.estadoLineaCopiada = false;
      }
    },
    GetOrderLineSelected(item) {
      Log(this, this.GetOrderLineSelected.name);
      this.orderLineSelected = item;
      this.LineItemOptions = true;
    },
    CloseLineItemOptions() {
      Log(this, this.CloseLineItemOptions.name);
      this.LineItemOptions = false;
    },
    PressBtnAdd() {
      Log(this, this.PressBtnAdd.name);
      f7.views.main.router.navigate('/frmOrderCompleteProducto/', {
        props: {
          palletMixed: true,
          nuevoPedido: this.nuevoPedido,
        },
      });
    },
    editLine(orderLineSelected) {
      Log(this, this.editLine.name);
      this.estadoLineaEditada = true;
      this.estadoLineaMixtaEdit = true;
      this.salesOrderLine = orderLineSelected;
      f7.views.main.router.navigate('/frmOrderCompleteProducto/', {
        props: {
          palletMixed: true,
          nuevoPedido: this.nuevoPedido,
        },
      });
    },
    duplicateLine(orderLineSelected) {
      Log(this, this.duplicateLine.name);
      this.estadoLineaEditada = true;
      this.estadoLineaCopiada = true;
      this.salesOrderLine = orderLineSelected;
      f7.views.main.router.navigate('/frmOrderCompleteProducto/', {
        props: {
          palletMixed: true,
          nuevoPedido: this.nuevoPedido,
        },
      });
    },
    async BackToMain() {
      Log(this, this.BackToMain.name);
      f7.views.main.router.navigate('/orderDetail/', {
        ignoreCache: true,
        reloadPrevious: true,
        props: {
          nuevoPedido: this.nuevoPedido,
          navbarBtn: true,
          mostrarBtnNextAdd: true,
          mostrarOnlyBtnAdd: false,
          mostrarToolbar: false,
        },
      });
      await sleep(500);
      f7.views.main.router.back();
    },
    async SaveMixedOrderLine() {
      Log(this, this.SaveMixedOrderLine.name);
      const actualOrder = { ...this.actualOrder };

      // se eleminan los registros del actualorder que tengan el mismo número de paletMixto para posteriormente incluir los editados
      actualOrder.lineasPedidoVenta = actualOrder.lineasPedidoVenta.filter((item) => item.PaleMixto !== this.mixedOrderLines[0].PaleMixto);

      this.mixedOrderLines.forEach((element) => {
        actualOrder.lineasPedidoVenta.push(element);
      });
      this.actualOrder = actualOrder;
      this.mixedOrderLines = null;
      await this.DeleteLines();
      this.BackToMain();
    },
    async DeleteLines() {
      if (this.deletedLines.length > 0) {
        const resultSave = await this.DeleteSaleOrderLines(this.deletedLines);
        if (resultSave == null) {
          HiNotification.Toast(this.$t('commercialization.info.couldNotDeleteLines'));
          return;
        }
        if (!resultSave.Valor) {
          HiNotification.Toast(resultSave.Mensaje);
        }
      }
    },
    async DeleteLine(line) {
      Log(this, this.DeleteLine.name);

      const alertTitle = this.$t('commercialization.deleteOrderLine.title');
      const alertText = this.$t('commercialization.deleteOrderLine.text');
      const resultConfirm = await ConfirmDialogGH(alertText, alertTitle);

      if (resultConfirm) {
        for (let i = 0; i < this.mixedOrderLines.length; i += 1) {
          const element = this.mixedOrderLines[i];
          if (element.IdTemporal === line.IdTemporal && element.Id === line.Id) {
            this.mixedOrderLines.splice(i, 1);
          }
        }
        if (line.Id !== 0) {
          this.deletedLines.push(line);
        }
      }
    },

    async DeleteSaleOrderLines(listLines) {
      HiDialog.Preloader(true, this.$t('commercialization.info.editingMixedPallet'), false);
      try {
        const result = await APIErp.callDeleteSaleOrderLine(listLines);
        HiDialog.Preloader(false);
        return result.data;
      } catch (error) {
        HiDialog.Preloader(false);
        HiNotification.Alert(error.response.data.Mensaje, this.$t('commercialization.info.couldNotDeleteSalesOrderLines'));
        return null;
      }
    },
  },
};
</script>

<style lang="scss">
.main-new-mixted-order-line {
  .page-content {
    overflow-y: hidden;
  }
  .container-navbar{
    .navbar-inner {
      .title {
          font-size: 16px;
          font-weight: 400;
      }
    }
  }
  .container-list{
    overflow-y: scroll;
    height: calc(100% - 120px);
    &__list{
      margin: 0;
      ul::before{
        content: none;
      }
      ul::after{
        content: none;
      }
      &--item{
        --f7-list-item-title-font-size: 16px;
        --f7-list-item-title-font-weight: 600;
        --f7-list-item-title-text-color: var(--his-berenjena);
        background-color: var(--his-mora-white);
        margin: 6px 12px 6px 12px;
        border: 1px solid var(--f7-list-item-border-color);
        border-radius: 8px;
        border-bottom: 4px solid var(--f7-list-item-border-color);
      }
    }
  }
  .content-button {
    --f7-button-font-size: 16px;
    position: fixed;
    width: 100%;
    bottom: 0;
    border-top: 1px solid var(--his-silver);
    background-color: #fff;
    height: 70px;
    &__save{
      margin: 10px 20px 10px 20px;
      height: 50px;
      background-color: var(--his-melon)
    }
  }
}
</style>
